export const IMAGE_BASE_URL = 'https://static-assets.vinted.com/images/landing/item-verification'
